<template>
    <div class="video-box" :style="{height:height}">
      <iws-video
        ref="video"
        :style="{margin:margin}"
        v-for="(item, index) in videoList"
        :key="index"
        :width="width"
        :height="height"
        :siteId="siteId"
        :channel="item.channel"
        :device-serial="item.serial"
        :device-code="item.code"
        :device-type="parseInt(item.deviceType)"
        :device-name="item.name"
        autoplay="1"
        :type="parseInt(item.apiType)"
				v-if='videoList.length>0'
      ></iws-video>
			<div v-else style="font-size: 50px;width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;color:#ccc;margin: 2vw;">未配置监控视频</div>
    </div>
</template>
<script>
import {queryLiveVideo} from '@/api/api'
import IwsVideo from '@comp/VideoPlay/IwsVideo'
export default {
  name: 'waterData',
  data() {
    return {
      videoList: [],
      width:0,
      height:0,
	  siteId:''
    }
  },
	props:{
		selectId:{
			default:'0',
			type:String
		},
    widthRatio:{
      default:0.47,
      type:Number
    },
    heightRatio:{
      default:0.25,
      type:Number
    },
    height:{
      default:'700px',
      type:String
    },
    margin:{
      default:'10px 20px 10px 0',
      type:String
    }
	},
  components: {
    IwsVideo,
  },
  mounted(){
    this.width=document.querySelector('.video-box').clientWidth*this.widthRatio
    this.height=document.querySelector('.video-box').clientWidth*this.heightRatio
    window.addEventListener('resize', ()=>{
      this.width=document.querySelector('.video-box').clientWidth*this.widthRatio
      this.height=document.querySelector('.video-box').clientWidth*this.heightRatio
    })
  },
  methods: {
    getVideoList(id) {
      var that = this
	  that.siteId = id
      queryLiveVideo({ siteId: id, pageSize: 100000 }).then((res) => {
        if (res.success) {
          that.videoList = res.result.records
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.video-box {
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
